import { createContext } from "react";

export interface WorkflowCommands {
  onSave?: () => void;
  onExecute?: () => void;
  onUndo?: () => void;
  onRedo?: () => void;
  onClear?: () => void;
  onNewWorkflow?: () => void;
}

export interface WorkflowCommandsContextType {
  commands: WorkflowCommands;
  registerCommands: (commands: WorkflowCommands) => void;
  unregisterCommands: () => void;
}

export const WorkflowCommandsContext =
  createContext<WorkflowCommandsContextType>({
    commands: {},
    registerCommands: () => {},
    unregisterCommands: () => {},
  });
